import React from "react";

import ContentCore from "../../../core/workingContent";

const TotalTaskUI = () => {
  return (
    <ContentCore />
  )
}

export default TotalTaskUI